export default __webpack_public_path__ + "static/media/curve.04b7a5fd.png";